/** @module api/remote */

import { apiCall } from '@/api/index'
import {
  apiV1AmperixPath,
  apiV1AmperixesPath,
  existApiV1EnergyManagerPath,
  remoteAccessApiV1EnergyManagerPath
} from '@/../lib/routes'

export function getAmperixes({ ctxt }) {
  return apiCall({
    path: apiV1AmperixesPath(ctxt)
  })
}

export function getAmperix({ ctxt, serialNumber }) {
  return apiCall({
    path: apiV1AmperixPath(ctxt, serialNumber)
  })
}

export function getEnergyManagerExists({ serialno }) {
  return apiCall({
    path: existApiV1EnergyManagerPath(serialno)
  })
}

export function openRemoteAccess({ serialNumber }) {
  return apiCall({
    method: 'POST',
    path: remoteAccessApiV1EnergyManagerPath(serialNumber)
  })
}
